<script setup lang="ts">
const { error = {} } = defineProps<{ error?: Record<string, any> }>();

const isAppInteractive = useIsAppInteractive();
</script>

<template>
  <div :data-cy="isAppInteractive && 'app-is-interactive'">
    <LayoutPageError :error="error" />
  </div>
</template>
